
import CATEGORY from '@generio-ai/library-legacy/constants/category'
import { Card } from '@/classes/card.js'
import { Transaction } from '@/classes/transaction.js'
import { generateUniqueIdentifier } from '@/utils/identifier.js'
import { requires } from '@/utils/validate.js'


export default {

    async newTransaction({ commit, getters }, {
        app,
        card,
        taskCommit,
        taskFetch
    }) {
        // verify app is registered
        if (!getters.isRegistered(app)) {
            throw new Error(`App '${app}' is not registered in flows store.`)
        }

        // ensure parameters are present
        requires(card, taskCommit, taskFetch)

        // get new index
        const newIndex = card.index + 1

        // remove existing cards at/from that new index
        commit('REMOVE_CARD', {
            app,
            index: newIndex
        })

        // if first card, create new flow id
        if (card.index === 0) {
            const flowId = generateUniqueIdentifier()
            commit('SET_FLOW_ID', {
                app,
                flowId
            })
            card.flow = flowId
        }

        // await the actual tasks
        const resolvedTaskCommit = await taskCommit
        const resolvedTaskFetch = await taskFetch

        // create transaction
        const transaction = new Transaction(
            app,
            card,
            resolvedTaskCommit,
            resolvedTaskFetch
        )

        // create new card
        const newCard = new Card(
            getters.getFlowId(app),
            newIndex,
            resolvedTaskFetch.component,
            resolvedTaskFetch.category,
            card.prompt.clone(),
            transaction
        )

        // ensure dual is True when category is model
        if (resolvedTaskFetch.category === CATEGORY.MODEL) {
            newCard.prompt.dual = true
        }

        // add new card
        commit('ADD_CARD', {
            app,
            card: newCard
        })
    }
}